import { useEffect, useState } from 'react';

/** Three sequential square dots — same motion as the boot splash. */
export function PixelLoadingDots({
  color,
  dotSize = 7,
  gap = 10,
}: {
  color: string;
  dotSize?: number;
  gap?: number;
}) {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setActive((value) => (value + 1) % 3);
    }, 320);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className="flex items-center" style={{ gap }}>
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          style={{
            width: dotSize,
            height: dotSize,
            backgroundColor: color,
            opacity: i === active ? 1 : 0.18,
            transition: 'opacity 120ms',
          }}
        />
      ))}
    </div>
  );
}
